import React from "react";

const DEFAULT_ABOUT = '/defaults/default-about.svg';
const handleImgError = (e) => { e.target.onerror = null; e.target.src = DEFAULT_ABOUT; };

function About({ sliderAbout }) {
  const imgSrc = sliderAbout?.[0]?.thubmnail
    ? `${process.env.REACT_APP_API_URL}/storage/${sliderAbout[0].thubmnail}`
    : DEFAULT_ABOUT;

  return (
    <div className="et_pb_section et_pb_section_4_tb_body section_aboutUS et_pb_with_background et_section_regular">
      <div className="et_pb_row et_pb_row_1_tb_body et_pb_equal_columns">
        <div className="et_pb_column et_pb_column_4_4 et_pb_column_1_tb_body et_pb_css_mix_blend_mode_passthrough et-last-child">
          <div className="et_pb_module et_pb_text et_pb_text_0_tb_body et_pb_text_align_left et_pb_bg_layout_light">
            <div className="et_pb_text_inner"><h1>About US</h1></div>
          </div>
          <div className="et_pb_module et_pb_image et_pb_image_0_tb_body">
            <span className="et_pb_image_wrap">
              <img decoding="async" src={imgSrc} alt={sliderAbout?.[0]?.name || 'About'} className="wp-image-4896" onError={handleImgError} />
            </span>
          </div>
          <div className="et_pb_module et_pb_text et_pb_text_1_tb_body et_pb_text_align_left et_pb_text_align_center-phone et_pb_bg_layout_light">
            <div className="et_pb_text_inner">
              <p>
                <strong className="yellow-color">{sliderAbout?.[0]?.name}</strong> {sliderAbout?.[0]?.link}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
